import React, { useMemo, useState } from 'react';

import { get, map } from 'lodash';
import { CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import SvgList from '../../components/SvgList';
import Popup from '../../components/Popup';
import { artistActions } from '../../actions';
import { formatDateToDisplay } from '../../utils';
import { Button } from '../../components';
import './ArtistDetailsFinance.scss';

const ArtistDetailsFinancials = (props) => {
  const { withDraws, setWithDraws, artist, withDrawStatus, isLoading } = props;
  const [cancelPopup, setCancelPopup] = useState({
    isOpen: false,
    id: null,
  });
  const [acceptPopup, setAcceptPopup] = useState({
    isOpen: false,
    id: null,
  });
  const [isConfirm, setIsConfirm] = useState(false);

  const total_past_withdrawls = useMemo(() => {
    return withDraws.reduce((acc, i) => {
      if (i.status === 'ACCEPTED') {
        return acc + i.amount;
      }
      return acc;
    }, 0);
  }, [withDraws]);

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  const withdrawsToRender = useMemo(() => {
    const statusValue = withDrawStatus.value || 'ALL';
    if (statusValue === 'ALL') return withDraws;
    return withDraws.filter((i) => i.status === statusValue);
  }, [withDrawStatus, withDraws]);

  const renderStatusCell = (params) => {
    switch (params.status) {
      case 'PENDING':
        return (
          <div className="btn-group" style={{ display: 'flex', columnGap: 15 }}>
            <div
              className="cancel-btn"
              onClick={(e) => {
                e.stopPropagation();
                setCancelPopup({ isOpen: true, id: params.id });
              }}
            >
              <SvgList name="cancel-outline-icon" />
            </div>
            <div
              className="accept-btn"
              onClick={(e) => {
                e.stopPropagation();
                setAcceptPopup({ isOpen: true, id: params.id });
              }}
            >
              Accept
              <SvgList name="check-icon" />
            </div>
          </div>
        );
      case 'ACCEPTED':
        return (
          <div className="button-group" style={{ display: 'inline-flex' }}>
            <button
              aria-describedby={'approve-popover'}
              variant="contained"
              className="button approve"
              style={{ '--button-color': '#DD4E47', display: 'flex', alignItems: 'center', columnGap: 10 }}
            >
              Approved
            </button>
          </div>
        );
      case 'REJECTED':
        return (
          <div className="button-group" style={{ display: 'inline-flex' }}>
            <button
              aria-describedby={'decline-popover'}
              variant="contained"
              className="button decline"
              style={{ '--button-color': '#DD4E47', display: 'flex', alignItems: 'center', columnGap: 10 }}
            >
              Declined
              <SvgList name="question-icon" />
            </button>
          </div>
        );
      default:
        return <span>{params.status}</span>;
    }
  };

  const handelAccpet = async () => {
    setIsConfirm(true);
    const isSuccess = await artistActions.updateWithdrawalStatus(acceptPopup.id, {
      status: 'ACCEPTED',
    });
    if (isSuccess) {
      const updatedWithdrwas = map(withDraws, (i) => {
        if (i.id === acceptPopup.id) {
          return {
            ...i,
            status: 'ACCEPTED',
            updated_at: new Date().toISOString(),
          };
        }
        return i;
      });
      setWithDraws(updatedWithdrwas);
      setIsConfirm(false);
    }
    setAcceptPopup(false);
  };

  const handleDecline = async () => {
    setIsConfirm(true);
    const isSuccess = await artistActions.updateWithdrawalStatus(cancelPopup.id, {
      status: 'REJECTED',
    });

    if (isSuccess) {
      const updatedWithdrwas = map(withDraws, (i) => {
        if (i.id === cancelPopup.id) {
          return {
            ...i,
            status: 'REJECTED',
            updated_at: new Date().toISOString(),
          };
        }
        return i;
      });
      setWithDraws(updatedWithdrwas);
      setIsConfirm(false);
    }
    setCancelPopup(false);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%', overflow: 'hidden', flexWrap: 'wrap' }}>
      <div className="finance-card-wrapper">
        <div className="card earning-card">
          <h4 className="title">Current Earnings</h4>
          <div className="value_wrapper">
            <span className="value">{`$${get(artist, 'total_revenue', 0).toFixed(2)}`}</span>
            <span className="percentage profit">
              {/* <span className="up_arrow">
                <SvgList name="up-arrow-icon" />
              </span> */}
            </span>
          </div>
        </div>
        <div className="card withdrawals-card">
          <h4 className="title">Total Past Withdrawls</h4>
          <div className="value_wrapper">
            <span className="value">{`$${total_past_withdrawls.toFixed(2)}`}</span>
          </div>
        </div>
      </div>
      <div
        className="withdrawals-table"
        style={{ flex: 1, height: '100%', width: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}
      >
        <h4 className="title">withdrawals</h4>

        <div style={{ display: 'flex', height: '100%', overflow: 'hidden', flex: 1, width: '100%' }}>
          <TableContainer className="tbl_wraper tbl_wrap" component={Paper}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell className="table_font result">Result</TableCell>
                  <TableCell>Date Initiated</TableCell>
                  <TableCell>Date Finished</TableCell>
                  <TableCell style={{ minWidth: 136 }}>Amount</TableCell>
                  {/* <TableCell style={{ minWidth: 136 }}>{numberWithCommas(Amount)} </TableCell> */}
                  <TableCell>Account Number</TableCell>
                  <TableCell className="status">Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading && (
                  <div className="table_initial_loader">
                    <CircularProgress />
                  </div>
                )}

                {withdrawsToRender?.length === 0 && !isLoading ? (
                  <div className="table_initial_loader">
                    <h4
                      style={{
                        textAlign: 'center',
                        marginBottom: 20,
                        fontSize: 20,
                        lineHeight: '32px',
                        maxWidth: '60%',
                        marginInline: 'auto',
                      }}
                    >
                      No Finance Found
                    </h4>
                  </div>
                ) : (
                  withdrawsToRender?.map((user, index) => (
                    <TableRow key={user.id} style={{ cursor: 'pointer' }}>
                      <TableCell className="result">
                        <div style={{ display: 'flex', columnGap: 30, alignItems: 'center' }}>
                          <span>#{index + 1}</span>
                        </div>
                      </TableCell>
                      <TableCell>{formatDateToDisplay(user.created_at)}</TableCell>
                      <TableCell>{formatDateToDisplay(user.updated_at)}</TableCell>
                      <TableCell style={{ minWidth: 136 }}>{`$${numberWithCommas(user.amount)}`}</TableCell>
                      <TableCell>{user.account_number}</TableCell>
                      <TableCell className="status">{renderStatusCell(user)}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>

      <Popup
        open={cancelPopup.isOpen}
        onClose={() =>
          !isConfirm &&
          setCancelPopup({
            isOpen: false,
            id: null,
          })
        }
      >
        <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px', maxWidth: '60%', marginInline: 'auto' }}>
          Are you sure, you want to decline this payment?
        </h4>
        <div className="button-group" style={{ '--button-color': '#6900af' }}>
          <Button
            onClick={() =>
              !isConfirm &&
              setCancelPopup({
                isOpen: false,
                id: null,
              })
            }
            className="button transparent"
          >
            Cancel
          </Button>
          <Button isLoading={isConfirm} onClick={handleDecline} className="button primary">
            Confirm
          </Button>
        </div>
      </Popup>

      <Popup
        open={acceptPopup.isOpen}
        onClose={() =>
          !isConfirm &&
          setAcceptPopup({
            isOpen: false,
            id: null,
          })
        }
      >
        <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px', maxWidth: '60%', marginInline: 'auto' }}>
          Are you sure, you want to accept this payment?
        </h4>
        <div className="button-group" style={{ '--button-color': '#6900af' }}>
          <Button
            onClick={() =>
              setAcceptPopup({
                isOpen: false,
                id: null,
              })
            }
            className="button transparent"
          >
            Cancel
          </Button>
          <Button isLoading={isConfirm} onClick={handelAccpet} className="button primary">
            Confirm
          </Button>
        </div>
      </Popup>
    </div>
  );
};

export default ArtistDetailsFinancials;
